import { render, staticRenderFns } from "./vFormTEXT.vue?vue&type=template&id=7d07d105&"
import script from "./vFormTEXT.vue?vue&type=script&lang=js&"
export * from "./vFormTEXT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports